export default "__VITE_ASSET__DhOqNVWA__"